import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../_services/category.service';
import { Category } from '../_models';
import { DocumentService } from '../_services/document.services';
import { AlertService } from '../_services/alert.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

  fileToUpload: File = null;
  category: Category;
  documentTitle: String = null;
  docId: String = null;
  properties = {};
  uploadMessage: Boolean = false;
  toggleUpload: Boolean = false;

  constructor(
    private categorySvc: CategoryService,
    private documentService: DocumentService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
  }

  handleFileInput(files: FileList) {
    const file = files.item(0);
    this.toggleUpload = true;
    this.fileToUpload = file;
  
} 

getCategory(){
  this.categorySvc.get("391")
        .subscribe(category => {
          this.category = category;
        })
}

uploadDocument() {
  //console.log(this.data);
  //console.log(this.fileToUpload);

  var systemProperties  = null;
  if (this.fileToUpload) {
      systemProperties = {
          "fileName": this.fileToUpload.name,
          "lastModifiedDate": new Date(this.fileToUpload.lastModified),
          "size": this.fileToUpload.size,
          "type": this.fileToUpload.type
      }
  }

  //build object to be sent to the service
  var uploadReq = {
      "title": this.documentTitle,
      "category_id": this.category.id,
      "meta_data": {},
      "system_properties": systemProperties
  }
  //populate meta-data
  this.category.meta_data_definition.properties.forEach(obj => {
      this.properties[obj.name] = obj.value;
  })
  //console.log("Array "+JSON.stringify(this.properties));
  uploadReq.meta_data = this.properties;

  // for (const data of this.category.meta_data_definition.properties) {
  
  //     var d = JSON.parse(JSON.stringify(data))
  //     console.log("Data "+ JSON.parse(JSON.stringify(d)));
  //     var prop = {
  //         "name": "",
  //         "value": ""
  //     }
  //     prop.name =  d["name"];
  //     prop.value = d["value"];
  //     console.log("properties "+prop.name);
  //     uploadReq.meta_data.push(prop);
  // }       

  this.documentService.uploadDocument(uploadReq)
      .subscribe(
          resp => {
              this.docId = resp["docId"];
              //console.log("url: "+JSON.parse(JSON.stringify(resp)));
              this.documentService.uploadFileToS3(resp["uploadUrl"],this.fileToUpload)
                  .subscribe (
                      resp => {
                              //reset form
                              this.documentTitle = null;
                              for (const data of this.category.meta_data_definition.properties) {
                                  data.value = null;       
                              }
                              this.uploadMessage = true;
                              this.toggleUpload = false;
                      }
                  ),
                  error => {
                      this.alertService.error(error);
                  }                        
          }
      ),
      error =>{
          this.alertService.error(error);
      }

}

trackByIndex(index, item) { 
  return item.id;
}

}
